<template>
    <div class="app">
        <div style="height:5rem"></div>
        <div class="joinpolicy-box">
            <div class="joinpolicy-title-box dis-cen">
                <div class="jmzc"></div>
                <div class="joinpolicy-china-title">加盟政策</div>
                <div class="joinpolicy-english-title">Franchise policy</div>
            </div>
            <div
                class="join-box dis-cen"
                style="margin-top:8rem"
            >
                <div class="join-son-box dis-between">
                    <div
                        class="join-son-wid"
                        @mouseover="allShopitem(1)"
                        @mouseleave="closetype(1)"
                    >
                        <img src="../../assets/image/img/newimg/jinyan.png" />
                        <div class="join-p">无需经验</div>
                    </div>
                    <div
                        class="join-son-wid"
                        @mouseover="allShopitem(2)"
                        @mouseleave="closetype(2)"
                    >
                        <img src="../../assets/image/img/newimg/fengxian.png" />
                        <div class="join-p">无需风险</div>
                    </div>
                    <div
                        class="join-son-wid"
                        @mouseover="allShopitem(3)"
                        @mouseleave="closetype(3)"
                    >
                        <img src="../../assets/image/img/newimg/jinji.png" />
                        <div class="join-p">无需经济压力</div>
                    </div>
                </div>
            </div>
            <div class="join-box dis-cen">
                <div class="join-content">
                    <div class="join-xian"></div>
                    <div
                        v-if="type == 1"
                        class="dis-cen"
                        style="height:276px"
                    >
                        <div class="dis">
                            <img
                                class="join-img"
                                src="../../assets/image/img/newimg/jinyan2.png"
                            />
                            <div style="margin:0 0 0 4rem">
                                <div class="join-p2">无需经验</div>
                                <div class="join-img2"></div>
                                <div class="join-p3">无须任何专业技术背景 ,无须任何行业经验积累 ,一周就能熟悉项目 ,一个月内就学会经营 ,助你一年挣不少钱!</div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-else-if="type == 2"
                        class="dis-cen"
                        style="height:276px"
                    >
                        <div class="dis">
                            <img
                                class="join-img"
                                src="../../assets/image/img/newimg/fengxian2.png"
                            />
                            <div style="margin:0 0 0 4rem">
                                <div class="join-p2">无需风险</div>
                                <div class="join-img2"></div>
                                <div class="join-p3">周全的区域运营代理盈利设计 ,地方平台整站运营 ,获得高利润! 面对8000亿唾手可得市
                                    场大蛋糕 ,极低的代理费用投入 ,成功创富不是梦!</div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-else-if="type == 3"
                        class="dis-cen"
                        style="height:276px"
                    >
                        <div class="dis">
                            <img
                                class="join-img"
                                src="../../assets/image/img/newimg/jingji2.png"
                            />
                            <div style="margin:0 0 0 4rem">
                                <div class="join-p2">无需经济压力</div>
                                <div class="join-img2"></div>
                                <div class="join-p3">只需一笔运营费,即可运营区域地方一版一幅图。</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default
    {
        data()
        {
            return {
                type: 1,
            }
        },
        methods:
        {
            allShopitem( val )
            {
                this.type = val
            },
            closetype()
            {
                // ...
            }

        }
    }
</script>

<style scoped="scoped">
    .risk-item p {
        color: #404040;
        font-size: 18px;
        font-weight: 500;
    }

    .risk-item img {
        width: 3.9375rem;
        height: 4.8125rem;
        margin-top: 3.125rem;
        margin-bottom: 1.875rem;
    }

    .risk-item {
        width: 100%;
        height: 13.625rem;
        text-align: center;
        margin: 0 0 1.875rem 0;
    }

    .experience-text {
        color: #3E3E3E;
        font-size: 0.875rem;
        line-height: 1.5rem;
        padding: 0 1.0625rem;
        text-indent: 2em;
        font-weight: 400;
    }

    .no-experience p {
        color: #FFFFFF;
        font-size: 1.125rem;
        text-align: center;
    }

    .no-experience img {
        width: 4.5625rem;
        height: 4.8125rem;
        margin-top: 3.125rem;
        margin-bottom: 1.875rem;
    }

    .no-experience {
        width: 100%;
        height: 13.625rem;
        background-color: #37A115;
        box-shadow: 0px 5px 7px 0px rgba(31, 31, 31, 0.39);
        text-align: center;
        margin: 0 0 1.875rem 0;
    }

    .joinpolicy-item,
    .risk-item-box {
        width: 16.5rem;
        height: auto;
        /* margin-right: 5.5rem; */
    }

    .joinpolicy-item-box {
        width: 75rem;
        height: auto;
        display: flex;
        justify-content: space-between;
        margin: 2.5rem auto 0 auto;
    }

    .joinpolicy-line {
        width: 15.25rem;
        height: 1px;
        background-color: #37A115;
        margin: 0 5px;
    }

    .joinpolicy-begin,
    .joinpolicy-over {
        width: 0.625rem;
        height: 0.625rem;
        border-radius: 50%;
        background-color: #37A115;
    }

    .joinpolicy-linebox {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.625rem;
    }

    .joinpolicy-china-title {
        text-align: center;
        /* font-size: 28px;
        color: #37A115; */
        margin-top: -2.8rem;
        font-size: 36px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        line-height: 34px;
    }

    .joinpolicy-english-title {
        text-align: center;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        line-height: 34px;
        margin-top: 0.6rem;
        letter-spacing: 4px
    }

    .joinpolicy-title-box {
        width: 100%;
        height: auto;
    }
</style>